import { Outlet } from 'react-router-dom';

function ViewEventsList() {
    return (
        <div className="">
            <Outlet />
        </div>
    );
}

export default ViewEventsList;
